import { render, staticRenderFns } from "./purchaseManage.vue?vue&type=template&id=541d4201&scoped=true"
import script from "./purchaseManage.vue?vue&type=script&lang=js"
export * from "./purchaseManage.vue?vue&type=script&lang=js"
import style0 from "./purchaseManage.vue?vue&type=style&index=0&id=541d4201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d4201",
  null
  
)

export default component.exports